// src/components/RoundedBarChart.js
import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// Registrar elementos necesarios
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

// Colores base
const CHART_COLORS = {
  red: "rgb(255, 99, 132)",
  blue: "rgb(54, 162, 235)",
};

// Función para hacer transparente un color
const transparentize = (color, opacity = 0.5) =>
  color.replace("rgb", "rgba").replace(")", `, ${opacity})`);

// Etiquetas y datos de prueba
const labels = ["January", "February", "March", "April", "May", "June", "July"];

const data = {
  labels,
  datasets: [
    {
      label: "Fully Rounded",
      data: [20, -10, 30, 25, -15, 5, 45],
      borderColor: CHART_COLORS.red,
      backgroundColor: transparentize(CHART_COLORS.red, 0.5),
      borderWidth: 2,
      borderRadius: Number.MAX_VALUE,
      borderSkipped: false,
    },
    {
      label: "Small Radius",
      data: [-25, 15, 20, 10, 30, 40, -5],
      borderColor: CHART_COLORS.blue,
      backgroundColor: transparentize(CHART_COLORS.blue, 0.5),
      borderWidth: 2,
      borderRadius: 5,
      borderSkipped: false,
    },
  ],
};

// Opciones de configuración
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Bar Chart",
    },
  },
};

const Chart5 = () => {
  return <Bar data={data} options={options} />;
};

export default Chart5;
